import {
  locationToFormDefaults,
  shipmentToFormDefaults,
  tagsToSeedOptions,
  vehiclesToFormDefaults,
} from '#/widgets/shipment-card'
import { paymentToFormDefaults } from '#/widgets/payment-card'
import { usPhoneDigits } from '#/shared/lib/format'
import { TransportType } from '#/shared/api/generated/shipment/models'
import type { ShipmentDetail } from '#/shared/api/generated/shipment/models'
import {
  LoadboardMethod,
  LoadboardTerms,
} from '#/shared/api/generated/loadboard/models'
import type { CustomerFormData } from '#/features/order-create'

import type { OrderFormDefaults } from '../ui/order-form'

/* eslint-disable complexity */
function customerToFormDefaults(
  brief: ShipmentDetail['customer'] | undefined,
): Partial<CustomerFormData> {
  return {
    firstName: brief?.first_name ?? '',
    lastName: brief?.last_name ?? '',
    company: brief?.company ?? '',
    companyPhone: usPhoneDigits(brief?.company_phone),
    email: brief?.email ?? '',
    email2: brief?.secondary_email ?? '',
    billingEmail: brief?.billing_email ?? '',
    phone: usPhoneDigits(brief?.phone),
    mobile: usPhoneDigits(brief?.secondary_phone),
    note: brief?.note ?? '',
  }
}
/* eslint-enable complexity */

export function shipmentToOrderFormDefaults(
  shipment: ShipmentDetail | undefined,
): OrderFormDefaults {
  return {
    customer: customerToFormDefaults(shipment?.customer),
    vehicles: vehiclesToFormDefaults(shipment),
    location: locationToFormDefaults(shipment),
    shipment: shipmentToFormDefaults(shipment),
    payment: paymentToFormDefaults(shipment),
    tagSeedOptions: tagsToSeedOptions(shipment),
  }
}

export function newOrderFormDefaults(): OrderFormDefaults {
  return {
    shipment: {
      trailer: TransportType.OPEN,
      shipDate: new Date(),
    },
    payment: {
      paymentMethod: LoadboardMethod.cashiers_check,
      paymentTerms: LoadboardTerms.cash_on_delivery,
    },
  }
}
